import { render, staticRenderFns } from "./ymqc_add.vue?vue&type=template&id=ed35ecf6&scoped=true&"
import script from "./ymqc_add.vue?vue&type=script&lang=js&"
export * from "./ymqc_add.vue?vue&type=script&lang=js&"
import style0 from "./ymqc_add.vue?vue&type=style&index=0&id=ed35ecf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed35ecf6",
  null
  
)

export default component.exports